import { render, staticRenderFns } from "./iconHam.vue?vue&type=template&id=4bd72640&"
import script from "./iconHam.vue?vue&type=script&lang=js&"
export * from "./iconHam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports